export enum RetirementStatus {
  MoreThan5 = 'MoreThan5',
  LessThan5 = 'LessThan5',
  Retired = 'Retired',
}

export interface RetirementStatusOption {
  label: string
  value: RetirementStatus
  links: { text: string; href: string }[]
  cta?: {
    label: string
    disclaimer: string
    button: {
      label: string
      href: string
    }
  }
}
